import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export function Field({ label, hint, children }: { label: React.ReactNode; hint?: React.ReactNode; children: React.ReactNode }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-sm font-semibold text-slate-700">{label}</Label>
      {children}
      {hint && <p className="text-xs text-slate-500">{hint}</p>}
    </div>
  );
}

export function BigInput(props: any) {
  return <Input {...props} className={`h-12 rounded-xl text-base bg-white ${props.className || ""}`} />;
}

export function MoneyInput({ value, onChange, ...rest }: { value: number | string; onChange: (v: number) => void; [k: string]: any }) {
  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 font-semibold">₹</span>
      <BigInput
        {...rest}
        inputMode="numeric"
        value={value === 0 || value ? String(value) : ""}
        onChange={(e: any) => onChange(Number(e.target.value.replace(/\D/g, "")) || 0)}
        className="pl-8 font-mono-num"
      />
    </div>
  );
}

export function Stepper({ value, onChange, min = 1, max = 12, testId }: { value: number; onChange: (v: number) => void; min?: number; max?: number; testId: string }) {
  const btn = "h-12 w-12 rounded-xl border border-slate-200 bg-white text-xl font-bold text-slate-700 pg-tap disabled:opacity-40";
  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <button type="button" data-testid={`${testId}-minus`} className={btn} disabled={value <= min} onClick={() => onChange(value - 1)}>−</button>
      <span data-testid={`${testId}-value`} className="w-10 text-center text-xl font-bold font-mono-num">{value}</span>
      <button type="button" data-testid={`${testId}-plus`} className={btn} disabled={value >= max} onClick={() => onChange(value + 1)}>+</button>
    </div>
  );
}

export function Chips<T extends string>({ options, value, onChange, testId }: { options: { value: T; label: string }[]; value: T; onChange: (v: any) => void; testId: string }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {options.map((o) => (
        <button
          type="button"
          key={o.value}
          data-testid={`${testId}-${o.value}`}
          onClick={() => onChange(o.value)}
          className={`h-11 px-4 rounded-full border text-sm font-semibold pg-tap ${value === o.value ? "bg-emerald-500 border-emerald-500 text-white" : "bg-white border-slate-200 text-slate-700 hover:bg-slate-50"}`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
